var e={container:"titleAndLink-module_container__2NIXg"};export{e as default};
